import { COOKIE_EXPIRE_TIME } from '@/utils/constants'
import { setCookie } from 'cookies-next'

export const setCookieWithMaxAge: typeof setCookie = (key, data, options = {}) => {
  return setCookie(key, data, {
    maxAge: COOKIE_EXPIRE_TIME,
    ...options
  })
}
